import { type OTPFormValues, otpFormSchema } from "@/actions/schema";
import { verifyOtpAction } from "@/actions/verify-otp-action";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@trendmap/ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@trendmap/ui/components/form";
import { Input } from "@trendmap/ui/components/input";
import { Loader2Icon } from "lucide-react";
import { useAction } from "next-safe-action/hooks";
import { useState } from "react";
import { useForm } from "react-hook-form";

interface MagicLinkSentProps {
  email: string;
  onBackToLogin: () => void;
}

export const MagicLinkSent = ({ email, onBackToLogin }: MagicLinkSentProps) => {
  const [manualInput, setManualInput] = useState<boolean>(false);

  const { execute, isExecuting } = useAction(verifyOtpAction);

  const form = useForm<OTPFormValues>({
    resolver: zodResolver(otpFormSchema),
    defaultValues: {
      pin: "",
    },
  });

  const onSubmit = form.handleSubmit((data) => {
    execute({ email: email, token: data.pin });
  });

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="text-2xl">Check your email</div>
        <div className="text-base">We've sent a temporary login link.</div>
        <div className="text-base">
          Please check your inbox at <strong>{email}</strong>.
        </div>
      </div>

      {manualInput ? (
        <Form {...form}>
          <form onSubmit={onSubmit}>
            <div className="grid gap-4">
              <FormField
                control={form.control}
                name="pin"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Input
                        placeholder="Enter code"
                        type="number"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button type="submit" className="">
                Continue with login code
              </Button>
            </div>
          </form>
        </Form>
      ) : (
        <div className="text-center flex flex-col gap-2">
          <Button variant="link" onClick={() => setManualInput(true)}>
            {isExecuting ? (
              <Loader2Icon className="h-4 w-4 animate-spin" />
            ) : (
              "Enter code manually"
            )}
          </Button>
          <Button variant="link" onClick={() => onBackToLogin()}>
            Back to login
          </Button>
        </div>
      )}
    </div>
  );
};
